export const FAMILIES_TABLES_COLS = [
  '',
  'COGNOME',
  'NOME',
  'ETÀ',
  'INDIRIZZO',
  'BADANTE ASSUNTA',
  'AZIONI',
] as const;

export const CARE_GIVERS_TABLE_COLS = [
  '',
  'COGNOME',
  'NOME',
  'ETÀ',
  'INDIRIZZO',
  'FAMIGLIA ASSEGNATA',
  'AZIONI',
] as const;

export const CALCULATIONS_HISTORY_TABLE_COLS = [
  'DATA',
  'FAMIGLIA',
  'BADANTE',
  'ESITO',
  '% COMP',
  'REPORT',
] as const;

export const TRANSACTIONS_TABLE_COLS = [
  'DATA',
  'STATO',
  'IMPORTO',
] as const;

export const SUGGESTED_CAREGIVERS_TABLE_COLS = [
  'COGNOME',
  'NOME',
  "ETA'",
  "NAZIONALITA'",
  "INDIRIZZO",
  'AZIONI'
] as const;

export const DEFUALT_ORDER_BY = 'tsCreated' as const;